import React from 'react';
import { Box, Typography } from '@mui/material';
import { HOURS } from './constants';
const TimeColumn = React.memo(() => <Box sx={{
  width: '80px',
  borderRight: '1px solid #fff',
  backgroundColor: '#f9f9f9'
}}>
    <Box sx={{
    height: '60px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderBottom: '1px solid #fff'
  }}>
      <Typography sx={{
      fontSize: '12px',
      color: '#666'
    }}>
        Time
      </Typography>
    </Box>
    {HOURS.map(hour => <Box key={hour} sx={{
    height: '30px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderBottom: '1px solid #fff',
    fontSize: '11px',
    color: '#666'
  }}>
        {String(hour).padStart(2, '0')}:00
      </Box>)}
  </Box>);
TimeColumn.displayName = 'TimeColumn';
export default TimeColumn;